module.exports = __webpack_public_path__ + "static/media/view-all.e189cf94.jpg";